export const ROLE_OPTIONS = [
  'SELLER',
  'ADMIN',
  'ARCHIVE',
  'SERVICE',
  'ESHOPM2M',
  'TELESALES',
  'ADMIN_INCIDENT',
  'TELESALES_RESELLER',
  'TELESALES_EXTERNAL'
];

export const ORGANIZATION_TYPES = [
  { value: 'DISTRIBUTOR', label: 'Distributor' },
  { value: 'DEALER', label: 'Dealer' },
  { value: 'SUBDEALER', label: 'Subdealer' },
  { value: 'FRONT_OFFICE', label: 'Front Office' },
];

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

export const SORT_OPTIONS = [
  { value: 'asc', label: 'Ascending Order' },
  { value: 'desc', label: 'Descending Order' },
];

export const ENTITY_STATUS_ACTIVE = 'a';
export const ENTITY_STATUS_DEACTIVE = 'd';

export const ENTITY_STATUS_OPTIONS = [
  { value: ENTITY_STATUS_ACTIVE, label: 'Active' },
  { value: ENTITY_STATUS_DEACTIVE, label: 'Deactive' },
];
